var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439",
    transform: "translate(0.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1977",
    "data-name": "Rectangle 1977",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(-0.463)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_00000038394049246713568260000012923108920998390947_",
    d: "M22.441,7.306c.015.22.015.441.015.662A14.5,14.5,0,0,1,7.861,22.563v0A14.517,14.517,0,0,1,0,20.259a10.393,10.393,0,0,0,1.221.074,10.293,10.293,0,0,0,6.37-2.2A5.135,5.135,0,0,1,2.8,14.571a5.131,5.131,0,0,0,2.316-.087A5.129,5.129,0,0,1,1,9.455V9.391a5.084,5.084,0,0,0,2.328.642A5.133,5.133,0,0,1,1.74,3.185,14.564,14.564,0,0,0,12.31,8.545a5.134,5.134,0,0,1,8.741-4.678,10.285,10.285,0,0,0,3.257-1.245,5.153,5.153,0,0,1-2.255,2.838A10.3,10.3,0,0,0,25,4.651,10.425,10.425,0,0,1,22.441,7.306Z",
    transform: "translate(13 12.75)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ca3412bcbdd0226f51585e28cd216648.svg";
export { ForwardRef as ReactComponent };